import React from 'react';
import { observer } from 'mobx-react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import get from 'lodash/get';

import { useDataStore } from 'state/DataStore';

import Sidebar from 'components/sidebar/Sidebar';
import SidebarLink from 'components/sidebar/SidebarLink';


const LevelsSidebar = observer(({ currentLevel, isSelectorScreen, onSelect }) => {
    const match = useRouteMatch();
    const history = useHistory();
    const dataStore = useDataStore();
    const { data: { levels } } = dataStore;
    
    const onlyShowIcon = dataStore.getSetting('apartment_settings', 'only_icon_menu');
    
    const joinPath = (...segments) => segments.join('/').replace(/\/+/g, '/');
    const levelPath = joinPath(match.url);
    
    const handleLevelClick = (levelSlug) => {
        if (isSelectorScreen) {
            // On selector screen, set the current level to show its "View" tab
            if (onSelect) {
                onSelect(levelSlug);
            }
        }
    };
    
    const handleViewClick = (levelSlug) => {
        // Navigate to the level when "View" is clicked
        const targetPath = joinPath(levelPath, levelSlug);
        history.push(targetPath);
    };
    
    return (
        <Sidebar numberLinks={levels?.length}>
            {levels && levels.map(({ slug, title: { rendered: title }, acf: { menu_icon } }) => (
                <SidebarLink
                    key={slug}
                    to={isSelectorScreen ? undefined : joinPath(levelPath, slug)}
                    icon={get(menu_icon, 'url', false)}
                    text={onlyShowIcon ? false : title}
                    isSelectorScreen={isSelectorScreen}
                    isCurrentLevel={isSelectorScreen && currentLevel === slug}
                    onLevelClick={() => handleLevelClick(slug)}
                    onViewClick={() => handleViewClick(slug)}
                />
            ))}
        </Sidebar>
    );
});


export default LevelsSidebar;
